import React, { useContext, useEffect } from "react";
import { ConfiguracoesContext } from "../../../contexts/Configuracoes/ConfiguracoesContext";
import Titulo from "../../Modal/ModaisConfigsPrimeiroAcesso/Titulo/Titulo";
import { Input } from "../../Input";
import { ToggleConfigurar } from "../../Toggle/ToggleConfigurar/ToggleConfigurar";
import { ContainerEntregaLocal } from "./styles";
import { useTheme } from "../../../contexts/Theme/ThemeContext";
import { cepMask, currencyMask } from "../../../services/Masks";
import { validateCep } from "../../../services/MasksValidations";
import { unmaskToNumbers } from "../../../services/Unmasks";
import PopoverInfo from "../../PopoverInfo/PopoverInfo";

interface EntregaLocalProps {
  configIn: "empresa" | "configuracoes";
}

const EntregaLocal: React.FC<EntregaLocalProps> = ({ configIn }) => {
  const { configuracoes, setConfiguracoes } = useContext(ConfiguracoesContext);

  const { theme } = useTheme();

  const [isTaxaValid, setIsTaxaValid] = React.useState(false);

  useEffect(() => {
    if (!configuracoes.frete.entregaLocal.cepDoLocal) {
      setConfiguracoes({
        ...configuracoes,
        frete: {
          ...configuracoes.frete,
          entregaLocal: {
            ...configuracoes.frete.entregaLocal,
            cepDoLocal: configuracoes.dados_empresa.endereco.cep,
          },
        },
      });
    }
    if (
      !Number.parseFloat(configuracoes.frete.entregaLocal.comTaxa.valor) &&
      configuracoes.frete.entregaLocal.comTaxa.ativo
    ) {
      setIsTaxaValid(false);
    } else {
      setIsTaxaValid(true);
    }
  }, [configuracoes.frete.entregaLocal.comTaxa]);

  return (
    <>
      <ContainerEntregaLocal configIn={configIn} theme={theme}>
        <div className="containerEntregaLocal">
          {configIn === "empresa" && (
            <Titulo
              justifyContent="center"
              flexDirection="column-reverse"
              titulo="Entrega local"
              subtitulo={``}
            />
          )}
          <div className="textoEntregaLocal fonteTexto">
            Ofereça frete especial para a sua região, a regra irá se aplicar para pedidos no CEP configurado abaixo. <br />
            Você pode definir prazo de expedição e se a entrega será com ou sem taxa.
            Facilite o envio e conquiste clientes próximos.
          </div>
          <div className="dropdown">
            <div className="cepContainer">
              <div className="containerInput">
                <Input
                  name="cepOrigem"
                  type="text"
                  label="CEP do local" 
                  value={configuracoes.frete.entregaLocal.cepDoLocal}
                  placeholder={"99200-000"}
                  mask={{
                    mask: cepMask,
                    maskValidation: validateCep,
                    unmask: unmaskToNumbers,
                  }}
                  required={true}
                  ignoreValidations={!configuracoes.frete.entregaLocal.ativo}
                  onChange={(newValue) => {
                    setConfiguracoes({
                      ...configuracoes,
                      frete: {
                        ...configuracoes.frete,
                        entregaLocal: {
                          ...configuracoes.frete.entregaLocal,
                          cepDoLocal: newValue,
                        },
                      },
                    });
                  }}
                />
              </div>
              <div className="containerInputDias">
                <Input
                maxLength={75}
                showMaxLength={false}
                ignoreValidations={!configuracoes.frete.entregaLocal.ativo}
                labelIcon={
                  <PopoverInfo
                    mensagem="Esse prazo é referente a separação dos produtos."
                    width="5"
                  />
                }
                type={"number"}
                label="Prazo de expedição" 
                name="diasEntregaEntregaLocal"
                value={configuracoes.frete.entregaLocal.diasEntregaEntregaLocal}
                placeholder={"Dias para separação do pedido"}
                onChange={(newValue) => {
                  setConfiguracoes({
                    ...configuracoes,
                    frete: {
                      ...configuracoes.frete,
                      entregaLocal: {
                        ...configuracoes.frete.entregaLocal,
                        diasEntregaEntregaLocal: newValue,
                      },
                    },
                  });
                }}
              ></Input>
              </div>
            </div>
            <div className="togglesContainer">
              <div className="togglesInnerContainer">
                <ToggleConfigurar
                  required={!configuracoes.frete.entregaLocal.comTaxa.ativo}
                  nome="Sem taxa"
                  value={configuracoes.frete.entregaLocal.semTaxa}
                  ignoreValidations={!configuracoes.frete.entregaLocal.ativo}
                  onChange={(newValue) => {
                    setConfiguracoes({
                      ...configuracoes,
                      frete: {
                        ...configuracoes.frete,
                        entregaLocal: {
                          ...configuracoes.frete.entregaLocal,
                          semTaxa: newValue,
                          comTaxa: {
                            ...configuracoes.frete.entregaLocal.comTaxa,
                            ativo: false,
                          },
                        },
                      },
                    });
                  }}
                />
                <ToggleConfigurar
                  nome="Com taxa"
                  value={configuracoes.frete.entregaLocal.comTaxa.ativo}
                  required={!configuracoes.frete.entregaLocal.semTaxa}
                  isValid={isTaxaValid}
                  invalidText="Configure uma taxa."
                  ignoreValidations={!configuracoes.frete.entregaLocal.ativo}
                  onChange={(newValue) => {
                    setConfiguracoes({
                      ...configuracoes,
                      frete: {
                        ...configuracoes.frete,
                        entregaLocal: {
                          ...configuracoes.frete.entregaLocal,
                          comTaxa: {
                            ...configuracoes.frete.entregaLocal.comTaxa,
                            ativo: newValue,
                          },
                          semTaxa: false,
                        },
                      },
                    });
                  }}
                />
                {configuracoes.frete.entregaLocal.comTaxa.ativo && (
                  <div className="taxaContainer">
                    <Input
                      name="taxaEntregaLocal"
                      type="text"
                      label="Informe a taxa de entrega"
                      mask={{
                        mask: currencyMask,
                        unmask: unmaskToNumbers,
                      }}
                      value={
                        Number.parseFloat(
                          configuracoes.frete.entregaLocal.comTaxa.valor,
                        ) != 0
                          ? configuracoes.frete.entregaLocal.comTaxa.valor.toString()
                          : ""
                      }
                      placeholder={"R$0,00"}
                      required={true}
                      ignoreValidations={!configuracoes.frete.entregaLocal.ativo}
                      onChange={(newValue) => {
                        setConfiguracoes({
                          ...configuracoes,
                          frete: {
                            ...configuracoes.frete,
                            entregaLocal: {
                              ...configuracoes.frete.entregaLocal,
                              comTaxa: {
                                ...configuracoes.frete.entregaLocal.comTaxa,
                                valor: newValue != "" ? newValue : "0",
                              },
                            },
                          },
                        });
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </ContainerEntregaLocal>
    </>
  );
};
export default EntregaLocal;
